// relativeDay.ts — reine (DOM-freie) Ableitung einer relativen Tagesangabe für
// Frist/TWV (A14): „heute", „morgen", „übermorgen", Wochentag (in dieser Woche),
// „nächste Woche <Wochentag>". Weit entfernte oder vergangene Tage → `null`
// (dann zeigt die Zelle nur das Datum). Testbar in der node-Umgebung.

const WEEKDAYS = [
  "Sonntag",
  "Montag",
  "Dienstag",
  "Mittwoch",
  "Donnerstag",
  "Freitag",
  "Samstag",
] as const;

/** Bringt einen Datums-String (reines „YYYY-MM-DD" ODER ISO mit Zeit) robust auf
 *  den lokalen Kalendertag (00:00). Ungültig → `null`. */
export function toLocalDay(iso?: string | null): Date | null {
  if (!iso) return null;
  const pure = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso);
  if (pure) {
    return new Date(Number(pure[1]), Number(pure[2]) - 1, Number(pure[3]));
  }
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  d.setHours(0, 0, 0, 0);
  return d;
}

function startOfDay(d: Date): Date {
  const x = new Date(d);
  x.setHours(0, 0, 0, 0);
  return x;
}

/**
 * Relative Tagesangabe zu `iso` bezogen auf `now` (Default: jetzt).
 *  0 → „heute", 1 → „morgen", 2 → „übermorgen",
 *  3–6 Tage → Wochentag, 7–13 Tage → „nächste Woche <Wochentag>",
 *  sonst (weiter weg oder Vergangenheit) → `null`.
 */
export function formatRelativeDay(iso?: string | null, now: Date = new Date()): string | null {
  const day = toLocalDay(iso);
  if (!day) return null;
  const today = startOfDay(now);
  const diff = Math.round((day.getTime() - today.getTime()) / 86_400_000);
  if (diff === 0) return "heute";
  if (diff === 1) return "morgen";
  if (diff === 2) return "übermorgen";
  if (diff >= 3 && diff <= 6) return WEEKDAYS[day.getDay()];
  if (diff >= 7 && diff <= 13) return `nächste Woche ${WEEKDAYS[day.getDay()]}`;
  return null;
}
